/**
 * ACL Error
 */
class ACLError extends Error {}
ACLError.prototype.name = 'ACLError'

export default ACLError
